import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ConnectIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 12H16M15 7L20 7C20.5523 7 21 7.44772 21 8V10C21 10.5523 20.5523 11 20 11H15C14.4477 11 14 10.5523 14 10V8C14 7.44772 14.4477 7 15 7ZM4 13H9C9.55228 13 10 13.4477 10 14V16C10 16.5523 9.55228 17 9 17H4C3.44772 17 3 16.5523 3 16V14C3 13.4477 3.44772 13 4 13Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

ConnectIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ConnectIcon);
